module.exports = __webpack_public_path__ + "img/home.1c32499f.svg";